var map = {
	"./campus.js": "5/65",
	"./coupon.js": "Niku",
	"./course.js": "+2IE",
	"./exchange.js": "L8QQ",
	"./index.js": "8NmS",
	"./mine.js": "plZs",
	"./order.js": "QZcc",
	"./pdf.js": "wYU2",
	"./study.js": "xtfG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kyiS";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules \.js$
// module id = kyiS
// module chunks = 62